<script setup lang="ts">
defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'blur', event: FocusEvent): void
  (e: 'focus', event: FocusEvent): void
}>()

withDefaults(
  defineProps<{
    modelValue?: string
    label: string
    placeholder?: string
    name: string
    disabled?: boolean
    required?: boolean
    options: string[]
    error?: string
  }>(),
  {}
)
</script>

<template>
  <label class="block">
    <span class="mb-1 text-sm font-medium text-gray-600">
      {{ label }} {{ !required ? `(${$t('forms.optional')})` : '' }}
    </span>

    <select
      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm transition focus:ring focus:ring-main-500 focus:ring-opacity-50"
      :value="modelValue"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
      @input="$emit('update:modelValue', ($event.target as HTMLSelectElement).value)"
    >
      <option v-if="placeholder" :value="''" selected>
        {{ placeholder }}
      </option>
      <option v-for="option in options" :key="option">{{ option }}</option>
    </select>

    <ErrorMessage v-if="error" :error="error" />
  </label>
</template>
